import Model from "../Model";

class KpiComercialGraphsUser extends Model{

    buildUrl ({ param }) {
        return ['kpizone/getbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiComercialGraphsUser;